var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M79 12A1 1 0 1 0 79 14A1 1 0 1 0 79 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e5e4",
    d: "M50 13A37 37 0 1 0 50 87A37 37 0 1 0 50 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M85 11A4 4 0 1 0 85 19A4 4 0 1 0 85 11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a5a5",
    d: "M13 27A2 2 0 1 0 13 31A2 2 0 1 0 13 27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M80 76A2 2 0 1 0 80 80 2 2 0 1 0 80 76zM26 72A4 4 0 1 0 26 80 4 4 0 1 0 26 72z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a5a5",
    d: "M27 85A2 2 0 1 0 27 89A2 2 0 1 0 27 85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.5 78A2.5 2.5 0 1 0 58.5 83 2.5 2.5 0 1 0 58.5 78zM23.029 68A.971.971 0 1 0 23.029 69.94200000000001.971.971 0 1 0 23.029 68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M85 30A1 1 0 1 0 85 32A1 1 0 1 0 85 30Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78 66A2 2 0 1 0 78 70 2 2 0 1 0 78 66zM79 33A1 1 0 1 0 79 35 1 1 0 1 0 79 33z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcef",
    d: "M33.5 62.5H37.5V74.5H33.5zM62.5 62.5H66.5V74.5H62.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcef",
    d: "M48.5 55.5H51.5V80.5H48.5z",
    transform: "rotate(-90 50 68)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M63,70H37v-4h26V70z M38,69h24v-2H38V69z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3e54",
    d: "M50 23.5A10.5 10.5 0 1 0 50 44.5A10.5 10.5 0 1 0 50 23.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.5 32.5H55.5V35.5H44.5z",
    transform: "rotate(-180 50 34)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcef",
    d: "M27 44.48H73V62.407H27z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M37.5 75h-4c-.276 0-.5-.224-.5-.5V62h5v12.5C38 74.776 37.776 75 37.5 75zM34 74h3V63h-3V74zM66.5 75h-4c-.276 0-.5-.224-.5-.5V62h5v12.5C67 74.776 66.776 75 66.5 75zM63 74h3V63h-3V74z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M49 62.5L58.5 44.5 50.5 44.5 41 62.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M41.25 63c-.079 0-.159-.019-.233-.058-.244-.129-.338-.432-.209-.676l9.5-18c.129-.245.434-.336.676-.209.244.129.338.432.209.676l-9.5 18C41.603 62.903 41.429 63 41.25 63zM49.25 63c-.079 0-.159-.019-.233-.058-.244-.129-.338-.432-.209-.676l9.5-18c.13-.245.434-.336.676-.209.244.129.338.432.209.676l-9.5 18C49.603 62.903 49.429 63 49.25 63z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M32.75 62.5L42.25 44.5 34.25 44.5 26.5 59.184 26.5 62.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M26.848 59.5c-.079 0-.159-.019-.233-.058-.244-.129-.338-.432-.209-.676l7.652-14.5c.13-.245.434-.336.676-.209.244.129.338.432.209.676l-7.652 14.5C27.2 59.403 27.026 59.5 26.848 59.5zM28 62.355c-.04 0-.079-.009-.116-.029-.123-.064-.169-.216-.104-.338l6.652-12.605c.063-.123.217-.167.337-.104.123.064.169.216.104.338l-6.652 12.605C28.177 62.307 28.09 62.355 28 62.355zM30.5 62.75c-.04 0-.079-.009-.116-.029-.123-.064-.169-.216-.104-.338l7.652-14.5c.064-.122.218-.167.337-.104.123.064.169.216.104.338l-7.652 14.5C30.677 62.702 30.59 62.75 30.5 62.75zM33 63c-.079 0-.159-.019-.233-.058-.244-.129-.338-.432-.209-.676l9.5-18c.129-.245.434-.336.676-.209.244.129.338.432.209.676l-9.5 18C33.353 62.903 33.179 63 33 63z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M65.25 62.5L73.431 47 73.5 44.5 66.75 44.5 57.25 62.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M57.5 63c-.079 0-.159-.019-.233-.058-.244-.129-.338-.432-.209-.676l9.5-18c.13-.245.434-.336.676-.209.244.129.338.432.209.676l-9.5 18C57.853 62.903 57.679 63 57.5 63zM65.5 63c-.079 0-.159-.019-.233-.058-.244-.129-.338-.432-.209-.676l7.652-14.5c.13-.246.434-.336.676-.209.244.129.338.432.209.676l-7.652 14.5C65.853 62.903 65.679 63 65.5 63zM55.5 36h-11c-.276 0-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5h11c.276 0 .5.224.5.5v3C56 35.776 55.776 36 55.5 36zM45 35h10v-2H45V35z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M50,24.4c5.293,0,9.6,4.307,9.6,9.6s-4.307,9.6-9.6,9.6s-9.6-4.307-9.6-9.6S44.707,24.4,50,24.4 M50,23c-6.075,0-11,4.925-11,11s4.925,11,11,11s11-4.925,11-11S56.075,23,50,23L50,23z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M72.6,45.4v16.2H27.4V45.4H72.6 M26,45v17c0,0.552,0.448,1,1,1h46c0.552,0,1-0.448,1-1V45 c0-0.552-0.448-1-1-1H27C26.448,44,26,44.448,26,45z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M49.348 57.75c-.04 0-.079-.009-.116-.029-.123-.064-.169-.216-.104-.338l6.652-12.605c.064-.123.218-.168.337-.104.123.064.169.216.104.338l-6.652 12.605C49.524 57.702 49.438 57.75 49.348 57.75zM45.848 59.25c-.04 0-.079-.009-.116-.029-.123-.064-.169-.216-.104-.338l7.652-14.5c.064-.123.217-.167.337-.104.123.064.169.216.104.338l-7.652 14.5C46.024 59.202 45.938 59.25 45.848 59.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.a0439142697b05d24fba334fb80be182.svg";
export { ForwardRef as ReactComponent };